import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleLogin } from './AuthApi';
import { Form, Input, Button, Typography } from 'antd';
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons';
import './App.css';

const { Title, Text } = Typography;

const LoginForm = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [error, setError] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  
  // Prevent scrolling when the component mounts
  useEffect(() => {
    // Save the original styles
    const originalStyle = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalHeight = document.body.style.height;
    
    // Disable scrolling
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    
    // Restore original styles when component unmounts
    return () => {
      document.body.style.overflow = originalStyle;
      document.body.style.position = originalPosition;
      document.body.style.height = originalHeight;
    };
  }, []);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      setError('');
      
      // Proceed with login
      const result = await handleLogin(values.username, values.password);
      
      if (result.success) {
        setIsLoggedIn(true);
        // Redirect after successful login
        setTimeout(() => {
          window.location.href = '/vault';
        }, 500);
      } else {
        setError(result.message || 'Login failed. Please check your credentials.');
      }
    } catch (error) {
      setError('An error occurred during login. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/');
  };

  return (
    <div className="full-page-form" style={{ 
      backgroundColor: '#ffffff',  // Changed from #f5f5f5 to white
      height: '100vh',
      width: '100vw',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'fixed',
      top: 0,
      left: 0
    }}>
      <div className="form-container" style={{ 
        width: '90%',
        maxWidth: '450px',
        backgroundColor: 'white',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
        borderRadius: '8px',
        padding: window.innerWidth < 480 ? '24px' : '32px',
        margin: 'auto',
        position: 'relative',
        transform: 'translateY(-35%)',
        transition: 'transform 0.3s ease'
      }}>
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '32px'
        }}>
          <Title level={2} style={{ 
            margin: 0, 
            color: '#1a237e', /* Using navbar brand color */
            fontWeight: 'bold',
            fontSize: '28px'
          }}>
            Client Login
          </Title>
        </div>
        
        {error && (
          <div style={{ 
            padding: '10px',
            marginBottom: '16px', 
            backgroundColor: '#ffebee',
            borderRadius: '4px',
            color: '#c62828'
          }}>
            {error}
          </div>
        )}
        
        <Form
          form={form}
          name="login_form"
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
          requiredMark={false}
          className="bold-form-inputs"

        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Please enter your username / email' }]}
            style={{ marginBottom: '20px' }}
          >
            <Input 
              prefix={<UserOutlined style={{ color: '#64748B' }} />} 
              placeholder="Username / email" 
              size="large"
              style={{ borderColor: '#CBD5E1', height: '45px' }}
            />
          </Form.Item>

          <Form.Item
            name="password"
            // label={<span style={{ color: '#000000', fontWeight: '500' }}>Password</span>}
            rules={[{ required: true, message: 'Please enter your password' }]}
            style={{ marginBottom: '24px' }}
          >
            <Input.Password 
              prefix={<LockOutlined style={{ color: '#64748B' }} />} 
              placeholder="Password" 
              size="large"
              style={{ borderColor: '#CBD5E1', height: '45px' }}
            />
          </Form.Item>

          <div style={{ 
            display: 'flex', 
            gap: '16px', 
            marginBottom: '16px',
            flexDirection: window.innerWidth <= 480 ? 'column' : 'row'
          }}>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              icon={<LoginOutlined />}
              size="large"
              style={{
                flex: '1',
                height: '45px',
                fontWeight: '500',
                fontSize: '16px',
                borderRadius: '6px',
                backgroundColor: '#1a237e',
                borderColor: '#1a237e'
              }}
            >
              Sign In
            </Button>
            
            <Button 
              onClick={handleCancel}
              size="large"
              style={{
                flex: '1',
                height: '45px',
                fontSize: '16px',
                borderRadius: '6px',
                borderColor: '#CBD5E1'
              }}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default LoginForm;